/**
 * 
 * @overview 组件
 * @author mll
 * @date 2019-8-20
 */

import {component_tool,framework_tool} from '../tool'
let {WizComponent} = component_tool;
let { WizContainer} = framework_tool;

import {
    LeftSideBar,NavBar,TopBar,
    Pages, Coming, P403, P404, P500, Result,SkinToolbox
} from './basic'

import Questionnair from './layouts/Questionnair/src'
let WizQuestionnair = Questionnair
export {
    WizComponent,
    WizContainer,
    LeftSideBar,NavBar,TopBar,
    Pages, Coming, P403, P404, P500, Result,SkinToolbox,
    WizQuestionnair
};

export default {};
